if (!window.Maximize.loadedScript.includes('variant-picker.js')) {
  window.Maximize.loadedScript.push("variant-picker.js");

  class VariantPicker extends HTMLElement {
    static cacheData = {};
    static switches = new WeakMap();
    constructor() {
      super();
      this.pickerType = this.dataset.pickerType || 'swatch';
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.url;
      this.isMainProduct = this.dataset.mainProduct === 'true';
      this.optionElements = this.querySelectorAll(`.variant-option`);
      this.optionLabelElements = Array.from(this.querySelectorAll(`.variant-option__label`));
      this.optionsSelectedValues = [];
      this.isEnableStickyATC = this.dataset.enableStickyAtc === 'true';
      this.currentVariantInfoElement = document.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      this.addtionalCurrentVariantInfoElement = document.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      this.currentVariant = JSON.parse(this.currentVariantInfoElement.textContent);
      this.sectionWrapper = document.getElementById(`shopify-section-${this.sectionId}`);
      this.specSectionElement = document.querySelectorAll(`.product-specifications-${this.productId}`);
      this.productDetailsElement = document.querySelector('product-details');
      this.tabSectionElement = document.querySelectorAll('.tabs-section');
      if (this.specSectionElement && this.isMainProduct) {
        this.specSectionIds = Array.from(this.specSectionElement).map(el => el.dataset.sectionId);
      }
      if (this.productDetailsElement && this.isMainProduct) {
        this.productDetailSectionId = this.productDetailsElement.dataset.sectionId;
      }
      if (this.tabSectionElement && this.isMainProduct) {
         this.tabSectionIds = Array.from(this.tabSectionElement).map(el => el.dataset.sectionId);
      }

      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.optionElements.forEach(el => {
        el.addEventListener('click', this.handleChangedOption.bind(this), { signal: this.listeners.signal });
        if (el.dataset.type === 'dropdown') el.addEventListener('keydown', event => {
          if ((event.key === 'Enter' || event.key === ' ') && this.querySelector('.variant-option[data-product-url]:not([data-product-url=""])')) {
            event.preventDefault();
            event.stopPropagation();
            el.click();
          }
        }, { signal: this.listeners.signal });
      })

      this.optionLabelElements.forEach(el => {
        el.addEventListener('keyup', el => {
          if (el.key === 'Enter' || el.key === ' ') {
            let optionInput = el.target.previousElementSibling;
            optionInput.click();
          }
        }, { signal: this.listeners.signal })
      })

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (event) => {
          if (event.detail.sectionId == this.sectionId) {
            VariantPicker.cacheData = {};
          };
        }, { signal: this.listeners.signal });
      }

      this.updateOptionSelectedValues();
      this.renderedOptionValues = [...this.optionsSelectedValues];

      if (this.isEnableStickyATC) {
        this.__initEventSticky();
      }
    }

    handleChangedOption(event) {
      const targetOption = event.currentTarget;
      if (targetOption.disabled || targetOption.getAttribute('aria-disabled') === 'true') {
        event.preventDefault?.();
        event.stopImmediatePropagation?.();
        return;
      }
      if (this.querySelector('.variant-option[data-product-url]:not([data-product-url=""])')) {
        this.optionsSelectedValues[Number(targetOption.dataset.optionPosition) - 1] = targetOption.dataset.optionValueId;
        return this.__switchProduct(targetOption.dataset.productUrl || this.pendingProductUrl || this.productUrl, { option: targetOption });
      }
      let position = targetOption.dataset.optionPosition;
      let listOptionSamePosition = this.querySelectorAll(`.variant-option[data-option-position='${position}']`);
      listOptionSamePosition.forEach(optionEle => {
        optionEle.classList[optionEle === targetOption ? 'add' : 'remove']('selected');
        optionEle.setAttribute("aria-selected", String(optionEle === targetOption));
      });
      const selectedOptionEle = this.querySelector(`.variant-option__selected-value[data-position='${position}']`);
      if (selectedOptionEle) {
        selectedOptionEle.innerHTML = targetOption.dataset.value;
      }

      this.updateOptionSelectedValues();
      this.__renderProductInfo();
    }

    updateOptionSelectedValues() {
      this.optionElements.forEach((optionEle) => {
        const optionPosition = optionEle.dataset.optionPosition;
        const idx = Number(optionPosition) - 1;
        if (optionEle.classList.contains('selected')) {
          this.optionsSelectedValues[idx] = optionEle.dataset.optionValueId;
        }
      });
    }

    async __switchProduct(productUrl, { option, history = false } = {}) {
      clearTimeout(this.selectionRestoreTimer);
      const scope = this.closest(this.isMainProduct ? '#MainContent' : '#QuickViewProductContent');
      const owner = scope || this.closest('.shopify-section') || this;
      if (owner.querySelector('[data-cart-transaction-pending]')) {
        this.optionsSelectedValues = [...this.renderedOptionValues];
        const error = new Error('Cart transaction in progress');
        error.cartTransactionPending = true;
        if (option) {
          // Let the dropdown's bubbling click handler finish before restoring it.
          this.selectionRestoreTimer = setTimeout(() => {
            if (this.isConnected) this.__productSwitchError(error, owner, history);
          }, 0);
        } else {
          this.__productSwitchError(error, owner, history);
        }
        return;
      }
      let request;
      try {
        const url = new URL(productUrl, window.location.href);
        if (url.origin !== new URL(window.location.href).origin || !/^https?:$/.test(url.protocol) || !url.pathname.includes('/products/'))
          throw new Error('Invalid product URL');
        if (url.pathname.startsWith('/products/'))
          url.pathname = (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + url.pathname;
        if (!history) {
          url.searchParams.delete('variant');
          url.searchParams.set('option_values', this.optionsSelectedValues.join(','));
        }
        // Showcase navigates with the complete native selection.
        if (!scope) {
          window.location.assign(url.href);
          return;
        }
        if (!this.isMainProduct) url.searchParams.set('section_id', this.sectionId);
        const previous = VariantPicker.switches.get(scope);
        previous?.abort();
        request = new AbortController();
        request.scope = scope;
        this.pendingRequest = request;
        this.pendingProductUrl = productUrl;
        request.controls = previous?.controls || Array.from(scope.querySelectorAll('.product-info__buy-buttons-wrapper, .sticky-add-to-cart__form, .shopify-payment-button'), el => [el, el.inert]);
        request.controls.forEach(([el]) => { el.inert = true; });
        VariantPicker.switches.set(scope, request);
        scope.dataset.productSwitchPending = 'true';
        scope.setAttribute('aria-busy', 'true');
        const response = await fetch(url.href, { signal: request.signal });
        if (!response.ok) throw new Error(`Product response ${response.status}`);
        const html = await response.text();
        if (request.signal.aborted || this.pendingRequest !== request || !this.isConnected) return;
        this.__commitProduct(html, url, { scope, option, history });
      } catch (error) {
        if (!request?.signal.aborted && this.isConnected && (!request || this.pendingRequest === request)) {
          this.optionsSelectedValues = [...this.renderedOptionValues];
          this.__productSwitchError(error, owner, history);
        }
      } finally {
        this.__finishProductSwitch(request);
      }
    }

    __finishProductSwitch(request) {
      if (!request) return;
      const scope = request.scope;
      if (VariantPicker.switches.get(scope) === request) {
        request.controls.forEach(([el, inert]) => { el.inert = inert; });
        delete scope.dataset.productSwitchPending;
        scope.removeAttribute('aria-busy');
        VariantPicker.switches.delete(scope);
      }
      if (this.pendingRequest === request) {
        delete this.pendingProductUrl;
        delete this.pendingRequest;
      }
    }

    __commitProduct(html, url, { scope, option, history }) {
      const page = new DOMParser().parseFromString(html, 'text/html');
      const next = page.getElementById(scope.id);
      const picker = next?.querySelector('variant-picker');
      const variant = picker && page.getElementById(`CurrentVariantInfo__${picker.dataset.sectionId}`);
      const currentVariant = variant && JSON.parse(variant.textContent);
      if (!next || !picker || !variant || (currentVariant !== null && !currentVariant?.id)) {
        throw new Error('Incomplete product response');
      }
      // Availability can change between render and click. Keep the current
      // product intact instead of committing an unavailable selection.
      if (option && !currentVariant?.available) {
        throw new Error('Selected product combination is no longer available');
      }
      if (currentVariant === null && !picker.closest('[data-ms-unavailable-combination]')) {
        throw new Error('Missing unavailable combination state');
      }
      // The theme's lazy loaders cannot report failed Alpine registration. Keep
      // the current product when a different template needs new executable code.
      const loadedScripts = new Set(Array.from(document.querySelectorAll('script[src]'), script => script.src));
      const unsupportedScript = Array.from(next.querySelectorAll('script')).some(script => {
        if (['application/json', 'application/ld+json'].includes(script.type)) return false;
        if (script.id === 'MSPdpConfig' && !script.src) return false;
        return script.src ? !loadedScripts.has(script.src) : !!script.textContent.trim();
      });
      if (unsupportedScript) {
        const error = new Error('Unsupported product template dependencies');
        error.productUrl = url.href;
        throw error;
      }
      const focusValue = option?.dataset.optionValueId;
      const focusSticky = currentVariant && option?.closest('.sticky-add-to-cart__wrapper');
      const committedUrl = new URL(picker.dataset.url, url);
      if (currentVariant) committedUrl.searchParams.set('variant', currentVariant.id);
      else if (url.searchParams.has('option_values')) committedUrl.searchParams.set('option_values', url.searchParams.get('option_values'));
      if (this.isMainProduct) {
        if (!history) {
          window.history.replaceState({ ...window.history.state, nativeProduct: true }, '', window.location.href);
          window.history.pushState({ nativeProduct: true }, '', committedUrl);
        }
        document.title = page.title;
        const metadataSelector = 'meta[property^="og:"], meta[name^="twitter:"], meta[name="description"]';
        document.head.querySelectorAll(metadataSelector).forEach(meta => meta.remove());
        page.head.querySelectorAll(metadataSelector).forEach(meta => document.head.append(meta.cloneNode(true)));
        const canonical = document.querySelector('link[rel="canonical"]');
        const nextCanonical = page.querySelector('link[rel="canonical"]');
        if (canonical && nextCanonical) canonical.href = nextCanonical.href;
      }
      // Keep the root stable: Alpine observes the new server-rendered children.
      scope.dispatchEvent(new CustomEvent('ms:product-unloading'));
      scope.className = next.className;
      scope.innerHTML = next.innerHTML;
      if (this.isMainProduct) delete window.MS_PDP;
      const config = scope.querySelector('#MSPdpConfig');
      if (config && this.isMainProduct) {
        const script = document.createElement('script');
        script.id = 'MSPdpConfig';
        script.textContent = config.textContent;
        config.replaceWith(script);
      }
      requestAnimationFrame(() => {
        if (this.isMainProduct) document.dispatchEvent(new CustomEvent('ms:product-swapped'));
        window.Shopify?.PaymentButton?.init();
        const target = focusValue && scope.querySelector(`${focusSticky ? '.sticky-add-to-cart__wrapper ' : 'variant-picker '}[data-option-value-id="${CSS.escape(focusValue)}"]`);
        const focus = target?.matches('input') ? scope.querySelector(`label[for="${CSS.escape(target.id)}"]`) : target?.closest('select-element')?.querySelector('.select-button') || target;
        (focus || scope.querySelector('variant-picker .select-button, variant-picker label[tabindex]') || scope).focus({ preventScroll: true });
        if (!currentVariant) scope.querySelector('.ms-unavailable-combination')?.scrollIntoView({ block: 'nearest' });
      });
    }

    __productSwitchError(error, scope, history) {
      if (!error.cartTransactionPending) console.error(error);
      scope.querySelectorAll('.variant-option[data-option-position][data-option-value-id]').forEach(option => {
        const selected = this.renderedOptionValues[Number(option.dataset.optionPosition) - 1] === option.dataset.optionValueId;
        option.classList.toggle('selected', selected);
        option.checked = selected;
        option.setAttribute('aria-selected', String(selected));
        if (selected) {
          option.closest('select-element')?.setSelectedOption(option);
          const label = scope.querySelector(`.variant-option__selected-value[data-position="${option.dataset.optionPosition}"]`);
          if (label) label.textContent = option.dataset.value;
        }
      });
      let alert = scope.querySelector('[data-product-switch-error]');
      if (!alert) {
        alert = document.createElement('p');
        alert.dataset.productSwitchError = '';
        alert.setAttribute('role', 'alert');
        this.append(alert);
      }
      alert.textContent = error.cartTransactionPending
        ? 'Eine Warenkorb-Aktion läuft. Bitte anschließend erneut auswählen.'
        : this.dataset.loadError;
      if (error.productUrl) {
        const targetUrl = new URL(error.productUrl, window.location.href);
        if (targetUrl.origin === new URL(window.location.href).origin) {
          targetUrl.searchParams.delete('section_id');
          const link = document.createElement('a');
          link.href = targetUrl.href;
          link.textContent = ' Produktseite öffnen';
          alert.append(link);
        }
      }
      if (history) {
        const restoredUrl = new URL(this.productUrl, window.location.href);
        if (this.dataset.currentVariantId) restoredUrl.searchParams.set('variant', this.dataset.currentVariantId);
        else restoredUrl.searchParams.set('option_values', this.renderedOptionValues.join(','));
        window.history.replaceState({ nativeProduct: true }, '', restoredUrl);
      }
    }

    async __renderProductInfo() {
      const buyButtonList = this.sectionWrapper.querySelectorAll(".product-info__buy-buttons-wrapper button")
      buyButtonList.forEach(button => {
        button.disabled = true
      });
      const url = `${this.productUrl}?option_values=${this.optionsSelectedValues.join(',')}&sections=${this.sectionId},${(this.specSectionIds || []).join(',')},${this.productDetailSectionId || ''},${(this.tabSectionIds || []).join(',')}`;
      let productResponseHTML = VariantPicker.cacheData[url];
      if (!productResponseHTML) {
        try {
          const response = await fetch(url);
          const contentType = response.headers.get('content-type');
        
        if (contentType && contentType.includes('application/json')) {
          const sectionsData = await response.json();
          const parsedSections = {};
          for (const [sectionKey, sectionHtml] of Object.entries(sectionsData)) {
            parsedSections[sectionKey] = new DOMParser().parseFromString(sectionHtml, "text/html");
          }
          
          productResponseHTML = parsedSections;
        } else {
          const text = await response.text();
          productResponseHTML = {
            [this.sectionId]: new DOMParser().parseFromString(text, "text/html")
          };
        }
         VariantPicker.cacheData[url] = productResponseHTML;
        } catch (error) {
          console.error(error)
        }
      }

      const productInfoHTML = productResponseHTML[this.sectionId];
      const productDetailInfoHTML = productResponseHTML[this.productDetailSectionId];
      if (productResponseHTML) {
        if (this.specSectionIds?.length > 0) {
          this.__updateSpecificationContent(this.specSectionIds, productResponseHTML, ".spec-col-content");
        }
        if (this.tabSectionIds?.length > 0) {
          this.__updateSpecificationContent(this.tabSectionIds, productResponseHTML, ".tabs__content__specification");
        }
      }
      if (productDetailInfoHTML) {
        this.__updateProductDetailSpecifications(productDetailInfoHTML);
      }

      const newVariantPickerEle = productInfoHTML.querySelector(`.section--${this.sectionId} variant-picker.variant-picker__wrapper`);
      this.dataset.currentVariantId = newVariantPickerEle?.dataset.currentVariantId || '';
      const variantId = this.dataset.currentVariantId;

      if (this.isMainProduct) {
        if (variantId.length > 0){
          window.history.replaceState({}, "", `${this.productUrl}?variant=${variantId}`);
        } else {
          window.history.replaceState({}, "", `${this.productUrl}`);
        }
      }

      this.__updateCurrentVariantInfo(productInfoHTML);

      if (this.currentVariant) {
        const selectors = [
          ".product-info__label-wrapper", // update labels
          ".product-template__properties", // update properties of the product
          ".product-info__volume-pricing"
        ];

        const selectorsUpdateWhenAvailable = [
          '.product-info__estimate-delivery-wrapper',
          '.product-info__rating',
          '.product-info__label-wrapper',
          '.product-form__dynamic-checkout',
          `#PickupAvailability__${this.sectionId}`
        ]

        selectors.forEach(selector => {
          this.__updateElements(productInfoHTML, selector);
        });

        const blockSelectors = [
          ".product-info__estimate-delivery-wrapper",
          ".product-info__price-wrapper", // update price
          ".product-info__identifier-wrapper", // update sku, barcode
          ".product-info__inventory-status-wrapper",
          ".product-info__back-in-stock-alert-wrapper",
          ".product-info__quantity-wrapper"
        ];

        blockSelectors.forEach(selector => {
          this.__updateBlockElements(productInfoHTML, selector);
        });

        this.__updateTableOfInformation(productInfoHTML)

        selectorsUpdateWhenAvailable.forEach(selector => {
          const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
          if (element) {
            element.classList.remove('is-unavailable');
          }
        })
      } else {
        this.__renderProductInfoWhenUnavailable();
      }

      this.__updateVariantPickerWhenChange(productInfoHTML);

      buyButtonList.forEach(button => {
        if (!button.ariaDisabled) {
          button.disabled = false;
        }
      });
      
      this.__dispatchChangeVariantEvent(productInfoHTML);

      if (this.isEnableStickyATC) {
        this.__renderStickyATC(productInfoHTML);
      }
    }

    __updateElements(productInfoHTML, selector) {
      const oldElement = document.querySelector(`.section--${this.sectionId} ${selector}`);
      const newElement = productInfoHTML.querySelector(`.section--${this.sectionId} ${selector}`);
      if (oldElement && newElement) {
        oldElement.innerHTML = newElement.innerHTML;
        if (oldElement.classList.contains('is-unavailable')) {
          oldElement.classList.remove('is-unavailable');
        }
      }
    }

    __updateBlockElements(productInfoHTML, selector) {
      const oldElements = document.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      oldElements.forEach(oldEl => {
        const blockId = oldEl.dataset.blockId;
        const newEl = productInfoHTML.querySelector(
          `.section--${this.sectionId} ${selector}[data-block-id="${blockId}"]`
        );
        if (oldEl && newEl) {
          oldEl.innerHTML = newEl.innerHTML;
          oldEl.classList.remove('is-unavailable');
        }
      });
    }

    __updateTableOfInformation(productInfoHTML) {
      const selector = ".table-content__row__last";
      const oldElements = document.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      const newElements = productInfoHTML.querySelectorAll(`.section--${this.sectionId} ${selector}`);
      oldElements.forEach((oldEle, index) => {
        if (newElements[index]) {
          oldEle.innerHTML = newElements[index].innerHTML;
        }
      });
    }

    __updateProductDetailSpecifications(productDetailInfoHTML) {
      const selector = ".product-details__specifications__content";
      const oldElements = document.querySelectorAll(`.section--${this.productDetailSectionId} ${selector}`);
      const newElements = productDetailInfoHTML.querySelectorAll(`.section--${this.productDetailSectionId} ${selector}`);
      oldElements.forEach((oldEle, index) => {
        if (newElements[index]) {
          oldEle.innerHTML = newElements[index].innerHTML;
        }
      });
    }
 
    __updateSpecificationContent(specSectionIds,productResponseHTML, selector) {
      specSectionIds.forEach(sectionId => {
        const sectionElement = productResponseHTML[sectionId];
        if (!sectionElement) return; 

        const oldElements = document.querySelectorAll(`.section--${sectionId} ${selector}`);
        const newElements = sectionElement.querySelectorAll(`.section--${sectionId} ${selector}`);

        oldElements.forEach((oldEle, index) => {
          if (newElements[index]) {
            oldEle.innerHTML = newElements[index].innerHTML;
          }
        });
      });
    }

    __updateVariantPickerWhenChange(productInfoHTML) {
      this.optionElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .variant-option[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
          el.checked = newOptionEle.classList.contains('selected');
          el.toggleAttribute('disabled', newOptionEle.hasAttribute('disabled'));
          el.setAttribute('aria-disabled', newOptionEle.getAttribute('aria-disabled') || 'false');

          el.innerHTML = newOptionEle.innerHTML;
          el.dataset.selectValue = newOptionEle.dataset.selectValue;
        }
      })

      this.optionLabelElements.forEach(el => {
        const optionValueId = el.dataset.optionValueId;
        const newOptionEle = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .variant-option__label[data-option-value-id="${optionValueId}"]`);
        if (newOptionEle) {
          el.classList[newOptionEle.classList.contains('disabled') ? 'add' : 'remove']('disabled');
          el.classList[newOptionEle.classList.contains('selected') ? 'add' : 'remove']('selected');
          el.tabIndex = newOptionEle.tabIndex;
          el.setAttribute('aria-disabled', newOptionEle.getAttribute('aria-disabled') || 'false');
        }
      })

      // fix for the dropdown type
      const listSelectElementLabels = this.querySelectorAll(`.select-button__label.variant-option__select-button__label`);
      listSelectElementLabels.forEach(el => {
        const position = el.dataset.optionPosition;
        const newEl = productInfoHTML.querySelector(`variant-picker.variant-picker__wrapper .select-button__label.variant-option__select-button__label[data-option-position="${position}"]`);
        if (newEl) {
          el.innerHTML = newEl.innerHTML.trim();
        }
      })

      const oldListSwatch = document.querySelectorAll(`.section--${this.sectionId} .swatch-option__label`);
      if (oldListSwatch.length > 0) {
        oldListSwatch.forEach((swatch) => {
          const optionId = swatch.getAttribute('for');

          const newSwatchLabel = productInfoHTML.querySelector(`.swatch-option__label[for=${optionId}]`)

          if (newSwatchLabel) {
            if (newSwatchLabel.dataset.swatchStyle === 'image') {
              swatch.style.setProperty('--swatch-image-value', newSwatchLabel.dataset.swatchValue);
            } else if (newSwatchLabel.dataset.swatchStyle === 'color') {
              swatch.style.setProperty('--swatch-color-value', newSwatchLabel.dataset.swatchValue);
            }
          }
        });
      }
    }

    __renderStickyATC (productInfoHTML) {
      const selectors = [
        `#StickyAddToCart__Image__${this.sectionId}`,
        `#StickyAddToCart__Variant__${this.sectionId}`,
        `#StickyAddToCart__Price__${this.sectionId}`,
        `.sticky-add-to-cart__form`
      ];

      selectors.forEach(selector => {
        this.__updateElements(productInfoHTML, selector);
      });
    }

    __initEventSticky() {
      this.stickyListener = (event) => {
        if (!this.isConnected) return;
        if (event.detail.option?.getAttribute('aria-disabled') === 'true') return;
        if (event.detail.optionsSelectedValues) {
          if (this.querySelector('.variant-option[data-product-url]:not([data-product-url=""])')) {
            return this.handleChangedOption({ currentTarget: event.detail.option });
          }
          this.optionsSelectedValues = event.detail.optionsSelectedValues;
          this.__renderProductInfo();
        }
      };
      document.addEventListener(`${STICKY_ATC_EVENT.optionChange}-${this.sectionId}`, this.stickyListener);
    }

    disconnectedCallback() {
      clearTimeout(this.selectionRestoreTimer);
      this.listeners?.abort();
      this.pendingRequest?.abort();
      this.__finishProductSwitch(this.pendingRequest);
      if (this.stickyListener) document.removeEventListener(`${STICKY_ATC_EVENT.optionChange}-${this.sectionId}`, this.stickyListener);
    }

    __updateCurrentVariantInfo(productInfoHTML) {
      const newCurrentVariantInfoElement = productInfoHTML.querySelector(`#CurrentVariantInfo__${this.sectionId}`);
      if (newCurrentVariantInfoElement) {
        this.currentVariantInfoElement.textContent = newCurrentVariantInfoElement.textContent;
        this.currentVariant = JSON.parse(newCurrentVariantInfoElement.textContent);
      }

      const newAdditionalCurrentVariantInfoElement = productInfoHTML.querySelector(`#AdditionalVariantInfo__${this.sectionId}`);
      if (newAdditionalCurrentVariantInfoElement) {
        this.addtionalCurrentVariantInfoElement.textContent = newAdditionalCurrentVariantInfoElement.textContent;
      }

      if (this.currentVariant) {
        this.isOptionExist = true;
        this.isOptionAvailable = this.currentVariant.available;
      } else {
        this.isOptionExist = false;
      }
    }

    __renderProductInfoWhenUnavailable() {
      const selectors = [
        // ".product-info__variant-picker", // update price
        ".product-info__price-wrapper", // update price
        ".product-info__identifier-wrapper", // update sku, barcode
        ".product-info__estimate-delivery-wrapper", // update estimate delivery
        ".product-info__label-wrapper", // update labels
        ".product-info__inventory-status-wrapper", // update inventory status
        ".product-info__rating", // update rating
        `#PickupAvailability__${this.sectionId}`,
        ".product-info__volume-pricing"
      ];

      selectors.forEach(selector => {
        const element = document.querySelector(`.section--${this.sectionId} ${selector}`);
        if (element) {
          element.classList.add('is-unavailable');
        }
      });
    }

    __dispatchChangeVariantEvent(updatedHTML) {
      document.dispatchEvent(
        new CustomEvent(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, {
          bubbles: true,
          detail: {
            productId: this.productId,
            currentVariant: this.currentVariant,
            sectionId: this.sectionId,
            isOptionAvailable: this.isOptionAvailable,
            isOptionExist: this.isOptionExist,
            previewMediaId: this.dataset.mediaId,
            optionsSelectedValues: this.optionsSelectedValues,
            updatedHTML: updatedHTML
          },
        })
      );
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  window.addEventListener('popstate', (event) => {
    if (event.state?.nativeProduct) document.querySelector('#MainContent variant-picker')?.__switchProduct(window.location.href, { history: true });
  });
  // Capture dynamic checkout and form submissions before old product handlers run.
  ['click', 'submit'].forEach(type => document.addEventListener(type, (event) => {
    if (event.target.closest('[data-product-switch-pending]') &&
        (type === 'submit' || event.target.closest('.product-info__buy-buttons-wrapper, .sticky-add-to-cart__form, .shopify-payment-button'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true));
}
